import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Table, Badge } from "react-bootstrap";
import { Bar, Pie, Doughnut, Line } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";

Chart.register(...registerables);

const calcularMedia = (arr) => {
  if (arr.length === 0) return 0;
  const soma = arr.reduce((total, num) => total + num, 0);
  return (soma / arr.length).toFixed(2);
};



// 🔹 Cores da Dashboard
const dashboardColors = {
  primary: "#00D4FF", // Azul-claro
  dark: "#ff7e00", // Azul-escuro
  success: "#00C897", // Verde
  warning: "#FF914D", // Laranja
  danger: "#FF4D4D", // Vermelho
  cardBackground: "#fff", // Fundo dos cards
};

// 🔹 Função para definir a cor do status
const getStatusVariant = (status) => {
  switch (status) {
    case "Não Confirmado":
      return "primary";
    case "Confirmado":
      return "success";
    case "Pendente":
      return "warning";
    case "Resolvido":
      return "secondary";
    default:
      return "dark";
  }
};

// 🔹 Função para definir a cor da criticidade
const getCriticidadeVariant = (criticidade) => {
  switch (criticidade) {
    case "Baixa":
      return "success";
    case "Média":
      return "primary";
    case "Alta":
      return "warning";
    case "Crítica":
      return "danger";
    default:
      return "dark";
  }
};

const Dashboard = () => {
  const [alerts, setAlerts] = useState([]);

  const tempoRespostaData = alerts
  .filter((a) => a.response_time !== null && a.response_time !== undefined)
  .map((a) => a.response_time);

  const tempoRespostaMedia = calcularMedia(tempoRespostaData);


  useEffect(() => {
    const token = "Bearer AC48311f6664bbc01c45e34a5e33abff8e";
  
    fetch("https://autonotify-api.mobilibrasil.com/api/alerts", {
      headers: {
        Authorization: token
      }
    })
      .then((response) => response.json())
      .then((data) => {
        setAlerts(data);
  
        data.forEach((alert) => {
          if (alert.ticket_id) {
            fetch(`https://autonotify-api.mobilibrasil.com/api/ticket_status/${alert.ticket_id}`, {
              headers: {
                Authorization: token
              }
            })
              .then((res) => res.json())
              .then((statusData) => {
                setAlerts((prevAlerts) =>
                  prevAlerts.map((a) =>
                    a.ticket_id === alert.ticket_id
                      ? { ...a, status: statusData.status }
                      : a
                  )
                );
              })
              .catch((err) =>
                console.error("Erro ao buscar status do GLPI:", err)
              );
          }
        });
      })
      .catch((error) => console.error("Erro ao buscar alertas:", error));
  }, []);
  

  // 🔹 Dados para os Gráficos
  const criticidadeCounts = alerts.reduce((acc, alert) => {
    acc[alert.severity] = (acc[alert.severity] || 0) + 1;
    return acc;
  }, {});

  const statusCounts = alerts.reduce((acc, alert) => {
    acc[alert.status] = (acc[alert.status] || 0) + 1;
    return acc;
  }, {});

  const atendenteCounts = alerts.reduce((acc, alert) => {
    if (alert.confirmed_by) {
      acc[alert.confirmed_by] = (acc[alert.confirmed_by] || 0) + 1;
    }
    return acc;
  }, {});



  // 🔹 Configuração dos Gráficos
  const pieData = {
    labels: Object.keys(criticidadeCounts),
    datasets: [
      {
        data: Object.values(criticidadeCounts),
        backgroundColor: [
          dashboardColors.warning,
          dashboardColors.danger,
          dashboardColors.primary,
          dashboardColors.success,
        ],
      },
    ],
  };

  const doughnutData = {
    labels: Object.keys(statusCounts),
    datasets: [
      {
        data: Object.values(statusCounts),
        backgroundColor: [
          dashboardColors.primary,
          dashboardColors.success,
          dashboardColors.warning,
          dashboardColors.dark,
        ],
      },
    ],
  };

  const atendenteData = {
    labels: Object.keys(atendenteCounts),
    datasets: [
      {
        label: "Atendimentos por Técnico",
        data: Object.values(atendenteCounts),
        backgroundColor: [
          dashboardColors.primary,
          dashboardColors.success,
          dashboardColors.warning,
          dashboardColors.danger,
        ],
      },
    ],
  };

  const tempoRespostaLineData = {
    labels: alerts.map((alert, index) => `Alerta ${index + 1}`),
    datasets: [
      {
        label: `Tempo Médio de Resposta: ${tempoRespostaMedia} min`,
        data: tempoRespostaData,
        borderColor: dashboardColors.primary,
        backgroundColor: dashboardColors.primary,
        fill: false,
        tension: 0.3,
      },
    ],
  };

  const chartOptions = {
    maintainAspectRatio: false,
    responsive: true,
  };

  return (
    <Container className="mt-4">
      <h2 className="text-center text-primary">Dashboard de Alertas</h2>

      {/* 🔹 Gráficos */}
      <Row className="mt-3">
        <Col md={6} lg={3}>
          <Card className="p-3" style={{ backgroundColor: dashboardColors.cardBackground }}>
            <h6 className="text-center">Distribuição de Criticidade</h6>
            <div style={{ height: "250px" }}>
              <Pie data={pieData} options={chartOptions} />
            </div>
          </Card>
        </Col>

        <Col md={6} lg={3}>
          <Card className="p-3" style={{ backgroundColor: dashboardColors.cardBackground }}>
            <h6 className="text-center">Alertas por Status</h6>
            <div style={{ height: "250px" }}>
              <Doughnut data={doughnutData} options={chartOptions} />
            </div>
          </Card>
        </Col>

        <Col md={6} lg={3}>
          <Card className="p-3" style={{ backgroundColor: dashboardColors.cardBackground }}>
            <h6 className="text-center">Atendimentos por Técnico</h6>
            <div style={{ height: "250px" }}>
              <Bar data={atendenteData} options={{ indexAxis: "y", ...chartOptions }} />
            </div>
          </Card>
        </Col>

        <Col md={6} lg={3}>
          <Card className="p-3" style={{ backgroundColor: dashboardColors.cardBackground }}>
            <h6 className="text-center">Tempo Médio de Resposta</h6>
            <div style={{ height: "250px" }}>
              <Line data={tempoRespostaLineData} options={chartOptions} />
            </div>
          </Card>
        </Col>
      </Row>

      {/* 🔹 Tabela de Logs */}
      <Row className="mt-5">
        <Col>
          <div className="table-container">
            <h4 className="text-dark mb-3">Logs de Alertas</h4>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Servidor</th>
                  <th>Alerta</th>
                  <th>Status</th>
                  <th>Ticket GLPI</th>
                  <th>Atendente</th>
                  <th>Telefone</th>
                  <th>Criticidade</th>
                  <th>Horário</th>
                  <th>Tempo de Resposta (min)</th>
                </tr>
              </thead>
              <tbody>
                {alerts.map((alert, index) => (
                  <tr key={alert.id}>
                    <td>{index + 1}</td>
                    <td>{alert.device_name}</td>
                    <td>{alert.trigger_name}</td>
                    <td>
                      <Badge bg={getStatusVariant(alert.status)}>{alert.status}</Badge>
                    </td>
                    <td>{alert.ticket_id || "N/A"}</td>
                    <td>{alert.confirmed_by || "Não Confirmado"}</td>
                    <td>{alert.confirmed_phone || "N/A"}</td>
                    <td>
                      <Badge bg={getCriticidadeVariant(alert.severity)}>{alert.severity}</Badge>
                    </td>
                    <td>{alert.timestamp}</td>
                    <td>{alert.response_time ? `${alert.response_time} min` : "N/A"}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Dashboard;
